import React from 'react'
import PropType from 'prop-types'
import Button from '../Button'
import Icon from '../../Icon'
import styles from './PrintButtonStyles'

function PrintButton({ handlePrint, className }) {
  const classes = styles()
  return (
    <Button
      variant="icon"
      className={handlePrint ? `${classes.button} ${className}` : `${classes.printButton} ${className}`}
      onClick={handlePrint && (() => handlePrint(true))}
    >
      <Icon color="#760074" iconName="Print" />
    </Button>
  )
}

PrintButton.defaultProps = {
  className: '',
  handlePrint: () => null,
}

PrintButton.propTypes = {
  className: PropType.string,
  handlePrint: PropType.func,
}

export default PrintButton
